import { Component } from '@angular/core'

@Component({
  selector: 'se-po-disability-select-docs',
  templateUrl: './disability-select-docs.component.html',
  styleUrls: ['./disability-select-docs.component.scss'],
  standalone: false,
})
export class DisabilitySelectDocsComponent {
}
